(function (jQuery, Drupal, window) {
  Drupal.behaviors.landscape_watchlist_16x9 = {
    attach: function (context) {
      const selector = '[data-component-id="nuplayer:landscape_watchlist_16x9"]';
      addObserverToQuerySelectorElements(selector, (isVisible, element) => {
        if (isVisible) {
          jQuery(element).imagePick();
        }
      });
      once('landscape_16x9-processed', 'body', context).forEach(() => {
        window.addEventListener('resize', () => {
          jQuery(selector).imagePickAll();
        });
      });
    },
  };
})(jQuery, Drupal, window);
